class Wishlist {
  constructor() {
    this.initEvents();
    this.metafield_id = "";
  }

  initEvents() {
    document
      .querySelectorAll('.add-to-wishlist:not([data-wishlist-customer="false"]')
      .forEach((button) => {
        button.addEventListener("click", this.addToWishlist.bind(this));
      });

    this.buttonsNoLogged = document.querySelectorAll(
      '[data-wishlist-customer="false"]'
    );

    this.initRemoveEvents();
  }

  initCartEvents() {
    document
      .querySelectorAll('.cart-items .add-to-wishlist:not([data-wishlist-customer="false"]')
      .forEach((button) => {
        button.addEventListener("click", this.addToWishlist.bind(this));
      });
  }

  initRemoveEvents() {
    document.querySelectorAll(".wishlist-item__remove").forEach((button) => {
      if (button.dataset.listener === "true") return;
      button.addEventListener("click", this.removeWishlistProduct.bind(this));
    });

    this.buttonsNoLogged.forEach((button) => {
      button.addEventListener('click', function () {
        document.querySelector('a.header__customer').click();
      });
    })
  }

  removeWishlistProduct(e) {
    let id = e.currentTarget.getAttribute("data-id");
    e.currentTarget.closest(".wishlist-item").classList.add("removed");
    this.addToWishlist(e);
  }

  updateWishlist(data) {
    let is_empty = data.products.length === 0;

    console.log(data.products.length);

    if (window.location.href.includes("wishlist")) {
      window.location.reload();
    }
  }

  async getUserById(id) {
    await fetch(
      " https://5volycajfb.execute-api.eu-west-3.amazonaws.com/dev/customers/" +
      id +
      "/metafields",
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    )
      .then((response) => response.json())
      .then((data) => {
        data.metafields.forEach((element) => {
          if (element.key == "wishlist_json") {
            return (this.metafield_id = element.id);
          }
        });
      })
      .catch((error) => { });
  }

  async addToWishlist(e) {
    let item = JSON.parse(
      e.currentTarget.dataset.productJson.replaceAll("'", '"')
    );

    window.WISHLIST = await this.fetchWishlist(item);

    if (window.WISHLIST.products === undefined) {
      window.WISHLIST = {};
      window.WISHLIST.products = [];
    }

    let already_exists = false;

    for (const product of window.WISHLIST.products) {
      if (product.id == item.id) {
        already_exists = true;
      }
    }

    let button = document.querySelector(
      '[data-action="add-wishlist"][data-product-id="' + item.id + '"]'
    );
    if (button) {
      button.dataset.wishlist = !already_exists;
    }

    if (!already_exists) {
      window.WISHLIST.products.push({
        title: item.title,
        id: item.id,
        handle: item.handle,
        price: item.price,
        tags: item.tags,
        url: `/products/${item.handle}`,
        featured_media: item.featured_media,
        featured_image: item.featured_image,
      });
    } else {
      window.WISHLIST.products = window.WISHLIST.products.filter(
        (product) => product.id != item.id
      );
    }

    await fetch(
      "https://5volycajfb.execute-api.eu-west-3.amazonaws.com/dev/customers/" +
      window.CUSTOMER_ID +
      "/wishlist",
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(window.WISHLIST),
      }
    )
      .then((response) => response.json())

      .then((data) => {
        this.updateWishlist(JSON.parse(data.metafield.value));
        return data;
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }

  async fetchWishlist() {
    return await fetch("/account?view=wishlist-json", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((data) => {
        console.log(data);
        return data;
      });
  }
}

const wishlist = new Wishlist();

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
    this.querySelectorAll('.cart-remove_container .wishlist-icon__container ').forEach((elem) => {
      elem.addEventListener('click', this.addToWishlist.bind(this));
    })
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    document.body.classList.add('overflow-hidden');
    document.body.classList.add('overflow-hidden-cart')
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
    document.body.style.overflow = '';
    document.body.classList.remove('overflow-hidden-cart')
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {

    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);

    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });

    wishlist.initCartEvents();

  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];

  }
}

customElements.define('cart-drawer-items', CartDrawerItems);






